import { render } from "./DialogGroupUseWarning.vue?vue&type=template&id=0f397c19&scoped=true"
import script from "./DialogGroupUseWarning.vue?vue&type=script&lang=js"
export * from "./DialogGroupUseWarning.vue?vue&type=script&lang=js"

import "./DialogGroupUseWarning.vue?vue&type=style&index=0&id=0f397c19&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0f397c19"

export default script